import { Injectable } from "@angular/core";
import { CoreLogService } from "../services/log.service";
import { CoreCOMService } from "../services/com.service";
import { ClientType } from "../services/com/comEnvironmentClient";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class NavigationBarProvider {

  constructor(private _coreLogService: CoreLogService,
    private _coreCOMService: CoreCOMService) {
  }

  /**set the BackGround Color of NavigationBar on android */
  public backgroundColorByHexString(): Promise<void> {
    const me = this;
    return new Promise((resolve, reject) => {
      if (me._coreCOMService.environment.client.isMobile && me._coreCOMService.environment.client.type === ClientType.android) {
        const statusBarBackGroundColor = getComputedStyle(document.documentElement).getPropertyValue("--statusbar-background-color").trim();
        me._coreCOMService.environment.navigationBar.backgroundColorByHexString(statusBarBackGroundColor)
          .then(() => {
            resolve();
          })
          .catch(e => {
            me._coreLogService.error("StatusBarProvider", "SetStausBarTextStyle", e);
          });
      } else {
        resolve();
      }
    });
  }
}
